import * as XLSX from 'xlsx'

export interface ExcelExportOptions {
  filename: string
  sheetName?: string
  headers: string[]
  rows: (string | number | null)[][]
  footerRows?: (string | number | null)[][]
}

export const exportToExcel = ({
  filename,
  sheetName = 'Sheet1',
  headers,
  rows,
  footerRows = [],
}: ExcelExportOptions): void => {
  const allRows = [headers, ...rows, ...footerRows]
  const ws = XLSX.utils.aoa_to_sheet(allRows)

  ws['!cols'] = headers.map((_, colIdx) => ({
    wch:
      Math.max(...allRows.map((row) => String(row[colIdx] ?? '').length)) + 2,
  }))

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)
  XLSX.writeFile(wb, `${filename}.xlsx`)
}
